import React, { useCallback, useEffect, useState } from 'react';

import alertHeader from '@assets/img/arts/alert-header.svg';
import { Button } from '@components/Button';
import { usePatchNotification } from '@hooks/mutation/usePatchNotification';
import { useNotification } from '@hooks/queries/useNotification';
import Dialog from '@material-ui/core/Dialog';
import { makeMuiStyles, useCommonStyles } from '@styles/index';
import { createStrings } from '@utils/local';
import clsx from 'clsx';

const strings = createStrings({
  ja: {
    title: '青島発サービス新登場！',
    messages: () => [
      '貿易条件(インコタームズ)EXWに対応',
      '華南エリアで集荷する新ルート『SHENZHEN+』が登場',
    ],
    chooseHint: 'いずれも予約申込の際、画面の選択肢からご指定いただけます。',
  },
});

export const useStyles = makeMuiStyles((theme, common) => ({
  alertContainer: {
    width: 960,
    backgroundColor: theme.palette.background.paper,
    [theme.breakpoints.down('xs')]: {
      width: 300,
    },
  },
  alertHeaderContainer: {
    ...common.flexCenter,
    ...common.textAlignCenter,
    position: 'relative',
    overflow: 'hidden',
    height: 100,
  },
  alertHeaderBackground: {
    position: 'absolute',
    left: 'auto',
    right: 'auto',
    bottom: 0,
  },
  alertTitle: {
    ...common.textWhite,
    ...common.normalText,
    ...common.fontWeight600,
    zIndex: 1,
    fontSize: 28,
    [theme.breakpoints.down('xs')]: {
      fontSize: 24,
    },
  },
  alertContent: {
    ...common.normalText,
    padding: `25px`,
  },
  alertPointDot: {
    width: 6,
    height: 6,
    backgroundColor: theme.palette.primary.main,
  },
  alertPointContainer: {
    ...common.flexInline,
    ...common.itemsCenter,
    columnGap: 12,
    lineHeight: 2,
  },
  buttonContainer: {
    margin: '1.5rem 200px 0',
    [theme.breakpoints.down('xs')]: {
      margin: '1.5rem 30px 0',
    },
  },
}));

export const QingdaoAlert: React.FC = () => {
  const patchNotifcation = usePatchNotification();
  const notifications = useNotification({ tag: 'qingdao_alert' });

  useEffect(() => {
    if (notifications.data) {
      setOpen(notifications.data.results.some((item) => item.has_read === false));
    }
  }, [notifications.data]);

  const [open, setOpen] = useState(false);

  const classes = {
    ...useCommonStyles(),
    ...useStyles(),
  };

  const onClose = useCallback(async () => {
    if (notifications.data && notifications.data.results.length > 0) {
      setOpen(false);
      await patchNotifcation.mutateAsync(notifications.data?.results[0].id);
    }
  }, [notifications.data]);

  return (
    <Dialog open={open} maxWidth={false}>
      <div className={classes.alertContainer}>
        <div className={classes.alertHeaderContainer}>
          <div className={classes.alertTitle}>{strings.title}</div>

          <img src={alertHeader} className={classes.alertHeaderBackground} aria-hidden />
        </div>

        <div className={classes.alertContent}>
          <div className={clsx(classes.textGray800, classes.normalText, classes.textAlignCenter)}>
            いつもご利用いただきありがとうございます。
            <br />
            いよいよ青島発のD2Dサービスが開始いたしました！
            <br />
            <br />
            詳細はこちらのページ{' '}
            <a href="https://d2dasia.com/06-01-2023/" target="_blank" className={classes.link}>
              https://d2dasia.com/06-01-2023/
            </a>{' '}
            からご確認いただけます。
          </div>

          <div className={classes.buttonContainer}>
            <Button
              style={{ width: '100%' }}
              text="OK"
              shape="round"
              size="small"
              color="primary"
              onClick={onClose}
            />
          </div>
        </div>
      </div>
    </Dialog>
  );
};
